
<container-element [ngSwitch]="tipo">
  <!-- máscara para cpf -->
  <span *ngSwitchCase="TipoColuna.Cpf">
    {{ exibirValorNaTabela(objeto, coluna) | mask: '000.000.000-00' }}
  </span>

  <!-- máscara para cnpj -->
  <span *ngSwitchCase="TipoColuna.Cnpj">
    {{ exibirValorNaTabela(objeto, coluna) | mask: '00.000.000/0000-00' }}
  </span>

  <!-- máscara para telefone -->
  <span *ngSwitchCase="TipoColuna.Telefone">
    {{ exibirValorNaTabela(objeto, coluna) | mask: '(00)00000-0000' }}
  </span>

  <!-- máscara para valores monetários -->
  <span *ngSwitchCase="TipoColuna.Valor">
    {{ exibirValorNaTabela(objeto, coluna) | currency }}
  </span>

  <!-- máscara para valores percentuais -->
  <span *ngSwitchCase="TipoColuna.Porcentagem">
    {{ exibirValorNaTabela(objeto, coluna) | multiplicarValor: 100 }}%
  </span>

  <!-- máscara para enum -->
  <span *ngSwitchCase="TipoColuna.Tag" [ngSwitch]="exibirValorNaTabela(objeto, coluna)" class="float-right">
    <tag-primecap *ngSwitchCase="false" status="INATIVO"></tag-primecap>
    <tag-primecap *ngSwitchCase="true" status="ATIVO"></tag-primecap>
    <tag-primecap *ngSwitchDefault [status]="exibirValorNaTabela(objeto, coluna)"></tag-primecap>
  </span>

  <!-- máscara para setor de startup -->
  <span *ngSwitchCase="TipoColuna.Setor" class="float-right">
    <setor-primecap [setorStartupTag]="objeto" height="2rem" width="125px"></setor-primecap>
  </span>

  <!-- máscara para valores percentuais com casas decimais precisas -->
  <span *ngSwitchCase="TipoColuna.PorcentagemComDecimal">
    {{ exibirValorNaTabela(objeto, coluna) | number: '1.5-5'}}%
  </span>

  <!-- máscara para datas -->
  <span *ngSwitchCase="TipoColuna.Data">
    {{ exibirValorNaTabela(objeto, coluna) | date: 'shortDate' }}
  </span>

  <!-- máscara para datas com mês e ano-->
  <span *ngSwitchCase="TipoColuna.DataMesAno">
    {{ exibirValorNaTabela(objeto, coluna) | date: 'MM/yyyy' }}
  </span>

  <!-- máscara para data e hora -->
  <span *ngSwitchCase="TipoColuna.DataEHora">
    {{ exibirValorNaTabela(objeto, coluna) | date: 'medium' }}
  </span>

  <!-- máscara para exibir logo da empresa -->
  <span *ngSwitchCase="TipoColuna.Logo" class="text-capitalize">
    <img class="logo" *ngIf="objeto.empresaLogo" [src]="linkLogoEmpresa | safeUrl" alt="Logo">
    {{ exibirValorNaTabela(objeto, coluna) }}
  </span>

  <!-- máscara para exibir sócio resposável -->
  <span *ngSwitchCase="TipoColuna.Socio" [ngSwitch]="exibirValorNaTabela(objeto, coluna)" class="float-right">
    <tag-primecap *ngSwitchCase="false" status="NAO"></tag-primecap>
    <tag-primecap *ngSwitchCase="true" status="SIM"></tag-primecap>
    <tag-primecap *ngSwitchDefault [status]="exibirValorNaTabela(objeto, coluna)"></tag-primecap>
  </span>

  <!-- máscara para email -->
  <span *ngSwitchCase="TipoColuna.Email">
    {{ exibirValorNaTabela(objeto, coluna)?.toLocaleString().toLowerCase() }}
  </span>

  <span *ngSwitchDefault class="text-capitalize">
    {{ exibirValorNaTabela(objeto, coluna)?.toLocaleString().toLowerCase() }}
  </span>
</container-element>

